import Button from "@components/atoms/Button";
import { TabButtonProps } from "./TabButton.types";
import styles from "./TabButton.module.scss";

export const TabButton = ({
  isActive,
  label,
  onClick,
  className = "",
}: TabButtonProps) => {
  return (
    <Button
      size="ds"
      onButtonClick={onClick}
      className={`${styles.tabButton} ${
        isActive ? styles.active : styles.inactive
      } ${className}`}
      ariaLabel={`Select ${label} tab`}
    >
      <span className={styles.label}>{label}</span>
    </Button>
  );
};
